<template>
  <div class="consult_mian" :style="{height:all_height}">
    <div v-if="load_show">
      <load></load>
    </div>
    <div style="background-color:rgb(51, 99, 151);padding: 1.25rem; color: white;" ref="con_h">
      <i class="el-icon-arrow-left" @click="back()">返回列表</i>
      <el-row style="margin-top: 0.625rem;">
        <span style=" word-wrap:break-word;" >
         问题：{{consult_info.list.title.content}}
        </span>
      </el-row>
      <el-row style="margin-top: 0.625rem; word-wrap:break-word;">
        <span v-if="consult_info.identity!='moderator'">
          顾问：{{consult_info.list.title.moderator}}
        </span>
        <span v-else>
          提问人：{{consult_info.list.title.companyee}}&nbsp;&nbsp;&nbsp;[{{consult_info.list.title.company}}]
        </span>
      </el-row>
      <el-row style="margin-top: 0.625rem; word-wrap:break-word;">
        时间：{{consult_info.list.title.time}}
      </el-row>
    </div>
    <div :style='{height:con_height}' class="over" ref="scrollContainer" style="padding: -1rem 1.25rem 1.25rem 1.25rem;">
      <el-row v-for="(item,index) in consult_info.list.list" :key="index">
          <el-row v-if="consult_info.identity=='moderator'">
            <el-row style="color: #999999;text-align: center; margin: 1.25rem 0;  word-wrap:break-word;">
              {{item.time}}
            </el-row>
           <el-row  v-if="item.from!=0">
             <el-row style="display: flex;">
               <el-row style="margin-right: 0.625rem;"><!-- {{consult_info.list.title.companyee}} -->
               <img src="../../../assets/share_consult_info_s.png" style="width: 10vw;" alt="">
               </el-row>
               <el-row class="guwen" v-html="item.content"></el-row>
             </el-row>
           </el-row>
           <el-row  v-else>
             <el-row style="display: flex;float: right;">
               <el-row  class="guwen" v-html="item.content">
               </el-row>
               <el-row style="margin-left: 0.625rem;">
                 <img src="../../../assets/share_consult_info_t.png" style="width: 10vw;" alt="">
               </el-row>
             </el-row>
           </el-row>
          </el-row>
          <el-row v-else>
            <el-row style="color: #999999;text-align: center; margin: 1.25rem 0;  word-wrap:break-word;">
              {{item.time}}
            </el-row>
           <el-row  v-if="item.from==0">
             <el-row style="display: flex;">
               <el-row style="margin-right: 0.625rem;">
               <img src="../../../assets/share_consult_info_t.png" style="width: 10vw;" alt="">
               </el-row>
               <el-row class="guwen" v-html="item.content"></el-row>
             </el-row>
           </el-row>
           <el-row  v-else>
             <el-row style="display: flex;float: right;">
               <el-row  class="guwen" v-html="item.content">
               </el-row>
               <el-row style="margin-left: 0.625rem;">
                 <img src="../../../assets/share_consult_info_s.png" style="width: 10vw;" alt="">
               </el-row>
             </el-row>
           </el-row>
          </el-row>
      </el-row>
    </div>
    <div ref="con_f"  style="padding: 0 1.25rem;">
      <el-row >
        <el-col :span='18'>
          <quill-editor
             :style="{height:quill_height}"
              v-model="consult_info.input"
              ref="myQuillEditor"
              :options="editorOption"
              @ready="onEditorReady($event)">
          </quill-editor>
        </el-col>
        <el-col :span='3' :offset='1'>
          <el-button  style="position: absolute;bottom:-41px;" type="primary"  @click="consultback(consult_info.list.title.num)">发 送</el-button>
        </el-col>
      </el-row>

      <!-- <el-input v-model="consult_info.input"  placeholder="请输入您想问的问题,点击发送" style="width: 100%;margin-right: 0.625rem;"></el-input> -->

   </div>

  </div>
</template>

<script>
  import load from '../../../components/load.vue';
  import { quillEditor } from 'vue-quill-editor'

  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  export default {
    data() {
      return {
        load_show:false,
        editorOption: {
          modules: {
            toolbar: [
              ['image'] // 链接、图片、视频
            ]
          },
          placeholder: ''
        },
        quill_height:'',
        quill_width:'',
        all_height:'',
        con_height:'',
        all_Width:'',
        consult_info:{
          list:{
          title:{},
          list:[]
          },
          show:false,
          title:'',
          input:'',
          type:'',//分类
          identity:'',//身份
        },
      }
    },
    mounted:function(){
      this.get_info(this.$route.query.msg)
      this.quill_height='3rem'
      this.all_height=document.documentElement.clientHeight+'px'
      this.con_height=document.documentElement.clientHeight-this.$refs.con_h.offsetHeight-this.$refs.con_f.offsetHeight-35+'px'
      this.all_Width=document.documentElement.clientWidth+'px'
      this.quill_width=document.documentElement.clientWidth-100+'px'
    },
    components: {
      quillEditor:quillEditor,
      load:load
    },
    methods: {
      back(){
        let _this=this
        _this.$router.push({path: '/share_consult', query: {type:localStorage.getItem('share_consult_type'),
        num:localStorage.getItem('share_consult_num'),openid:localStorage.getItem('share_consult_openid')}})
      },
      // 准备富文本编辑器
        onEditorReady(quill) {
          // toolbar标题
          const titleConfig = [
            { Choice: '.ql-image', title: '图像' },
          ]
          for (let item of titleConfig) {
                  let tip = document.querySelector('.quill-editor ' + item.Choice)
                  if (!tip) continue
                  tip.setAttribute('title', item.title)
                }
        },
      consultback(fid){
        let _this=this
            let data={
           type:_this.consult_info.identity,
           content:_this.consult_info.input,
           fid:fid
             }
        _this.axios.post('/v2/temp/wx_gxp_save', {
          data: data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
               _this.$message.success(res.data.msg)
               _this.consult_info.input=''
               _this.get_info(_this.$route.query.msg)
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      get_info(num){
        let _this=this
        _this.axios.get('/v2/temp/wx_gxp_info',{params:{
        msg:num,
        type:_this.$route.query.type,
        num:_this.$route.query.num,
        openid:_this.$route.query.openid
        }}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.consult_info.list=res.data.data
              _this.consult_info.show=true
              _this.consult_info.title=res.data.data.title.name
              _this.consult_info.type=res.data.data.title.type
              _this.consult_info.identity=res.data.data.type
              let type={
                content:res.data.data.title.content,
                from:"1"
              }
              _this.consult_info.list.list.unshift(type)

              _this.$nextTick(() => {
                _this.load_show=true
                let timer = setTimeout(() => {
                    const container = _this.$refs.scrollContainer;
                    container.scrollTop = container.scrollHeight;
                    clearTimeout(timer)
                    _this.load_show=false
                    }, 100)

              });
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
     },
  }
</script>

<style scoped>
.over{
    overflow: auto;
    padding: 0 1.25rem;
    margin-bottom: 0.625rem;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(154, 155, 158);
    border-radius: 10px;
  }
  .guwen{
    background-color: #f6f8ff; border-radius: 4px;padding: 0.625rem;
  }
  .guwen1{
     /* word-wrap:break-word; */
     width: calc(100%-100px);
  }

  .consult_mian{
    background-color: #f3f3f3;
  }
  .guwen1 >>> img {
  margin: 20px;
  width: 70vw;
  }
  .guwen >>> img {

   width: 50vw;
  }
</style>



// WEBPACK FOOTER //
// src/view/share/consult_teacher/consult_info.vue